const timeAPI = {
  DAYS: 1000 * 60 * 60 * 24,
  HOURS: 1000 * 60 * 60,
  MINUTES: 1000 * 60,
  SECONDS: 1000,
};
let now = Date.now();
let countdownTicker;
const countdowns = [];

function tick() {
  now = Date.now();
  countdowns.forEach((countdown) => {
    countdown.now = now;
  });
}

function startTicking(countdown) {
  if (!countdowns.includes(countdown)) {
    countdowns.push(countdown);
  }
  if (countdownTicker === undefined) {
    countdownTicker = window.setInterval(tick, 1000);
  }
}

function stopTicking(countdown) {
  const index = countdowns.indexOf(countdown);
  if (index > -1) {
    countdowns.splice(index, 1);
  }
  if (countdowns.length === 0) {
    window.clearInterval(countdownTicker);
    countdownTicker = undefined;
  }
}

function calculateDiff(time, now, start) {
  if (time < now || (start && now < start)) {
    return false;
  }

  const diff = {};
  let timeDiff = Math.abs(now - time);

  diff.days = Math.floor(timeDiff / timeAPI.DAYS);
  timeDiff %= timeAPI.DAYS;
  diff.hours = Math.floor(timeDiff / timeAPI.HOURS);
  timeDiff %= timeAPI.HOURS;
  diff.minutes = Math.floor(timeDiff / timeAPI.MINUTES);
  timeDiff %= timeAPI.MINUTES;
  diff.seconds = Math.floor(timeDiff / timeAPI.SECONDS);

  const formattedTime = [];
  (diff.seconds || diff.minutes || diff.hours || diff.days) && formattedTime.push(diff.seconds);
  (diff.minutes || diff.hours || diff.days) && formattedTime.push(diff.minutes);
  (diff.hours || diff.days) && formattedTime.push(diff.hours);
  (diff.days) && formattedTime.push(diff.days);

  diff.formatted = formattedTime.reverse().map((number) => (number < 10 ? '0' : '') + number).join(':');

  return diff;
}

export const TimerBehavior = (superClass) => class extends superClass {
  static get properties() {
    return {
      starttime: {
        type: String,
      },

      endtime: {
        type: String,
      },

      now: {
        type: Number,
      },

      timeUntil: {
        type: Object,
        attribute: 'time-until',
      },

      timeRemaining: {
        type: Object,
        attribute: 'time-remaining',
      },
    };
  }

  set starttime(starttime) {
    this._starttime = Date.parse(starttime);
  }

  get starttime() {
    return this._starttime;
  }

  set endtime(endtime) {
    this._endtime = Date.parse(endtime);
  }

  get endtime() {
    return this._endtime;
  }

  set now(now) {
    this._now = now;
    this.timeUntil = calculateDiff(this._starttime, this._now);
    this.timeRemaining = calculateDiff(this._endtime, this._now, this._starttime);
  }

  get now() {
    return this._now;
  }

  constructor(props) {
    super(props);
    this._starttime = 0;
    this._endtime = 0;
    this.now = now;
  }

  connectedCallback() {
    super.connectedCallback();
    startTicking(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    stopTicking(this);
  }
};
